var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCivilHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.573,
    height: 56.279,
    viewBox: "0 0 53.573 56.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44412",
    "data-name": "Group 44412",
    transform: "translate(-6396.71 4491.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26718",
    "data-name": "Path 26718",
    d: "M25.844,553h4.062a3,3,0,0,1,3,3v15.039a3,3,0,0,1-3,3H25.844a3,3,0,0,1-3-3V556a3,3,0,0,1,3-3",
    transform: "translate(6396.71 -5044)",
    fill: "#b3b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26719",
    "data-name": "Path 26719",
    d: "M40.237,576.407H32.862a.939.939,0,0,0-.922.955v.955a.939.939,0,0,1-.922.955H25.483a.939.939,0,0,1-.922-.955v-.955a.939.939,0,0,0-.923-.955H16.259a.955.955,0,0,0,0,1.909h6.457a2.817,2.817,0,0,0,2.767,2.864h5.534a2.817,2.817,0,0,0,2.767-2.864h6.453a.955.955,0,0,0,0-1.909",
    transform: "translate(6396.71 -5044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26720",
    "data-name": "Path 26720",
    d: "M49.78,575.6a21.452,21.452,0,0,0-15.921-19.967,2.808,2.808,0,0,0-2.8-2.633H25.437a2.809,2.809,0,0,0-2.8,2.64A21.4,21.4,0,0,0,6.715,575.6a4.694,4.694,0,0,0-3.787,4.6v1.876a2.814,2.814,0,0,0,2.814,2.814H6.68v6.565a.938.938,0,0,0,.938.938h5.387a15.88,15.88,0,0,0,1.148,2.774l-3.8,3.812a.938.938,0,0,0,0,1.326l5.3,5.3a.938.938,0,0,0,1.326,0l3.812-3.8a15.927,15.927,0,0,0,2.775,1.149v5.387a.938.938,0,0,0,.938.938H32a.938.938,0,0,0,.938-.938v-5.394a15.6,15.6,0,0,0,2.769-1.155l3.817,3.808a.938.938,0,0,0,1.326,0l5.3-5.3a.938.938,0,0,0,0-1.326l-3.813-3.814a15.612,15.612,0,0,0,1.155-2.77h5.387a.938.938,0,0,0,.938-.938v-6.565h.938a2.814,2.814,0,0,0,2.814-2.814V580.2a4.693,4.693,0,0,0-3.793-4.6m-1.834,14.915H42.787a.937.937,0,0,0-.908.7,13.741,13.741,0,0,1-1.51,3.618.939.939,0,0,0,.141,1.144l3.652,3.658-3.974,3.976-3.66-3.652a.938.938,0,0,0-1.145-.141,13.728,13.728,0,0,1-3.616,1.51.938.938,0,0,0-.7.91V607.4H25.437v-5.162a.937.937,0,0,0-.7-.908,14.02,14.02,0,0,1-3.632-1.5.938.938,0,0,0-1.139.143l-3.651,3.643-3.974-3.974,3.643-3.651a.938.938,0,0,0,.143-1.139,14.011,14.011,0,0,1-1.5-3.631.938.938,0,0,0-.911-.706H8.555v-5.628H19.319a9.379,9.379,0,1,0,17.863,0H47.946Zm-12.755-5.628a7.5,7.5,0,1,1-13.88,0ZM51.7,582.071a.938.938,0,0,1-.938.938H5.742a.938.938,0,0,1-.938-.938V580.2a2.814,2.814,0,0,1,1.876-2.641V580.2a.938.938,0,0,0,1.876,0v-3.753a19.558,19.558,0,0,1,14.072-18.858V569.88a.938.938,0,0,0,1.876,0V555.812a.938.938,0,0,1,.938-.938h5.627a.938.938,0,0,1,.938.938V569.88a.938.938,0,0,0,1.876,0V557.575a19.66,19.66,0,0,1,14.068,18.87V580.2a.938.938,0,0,0,1.876,0v-2.643A2.814,2.814,0,0,1,51.7,580.2Z",
    transform: "translate(6396.71 -5044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26721",
    "data-name": "Path 26721",
    d: "M36.686,568.27a.956.956,0,0,0,.955-.955v-5.726a.955.955,0,0,0-1.909-.062c0,.021,0,.041,0,.062v5.727a.955.955,0,0,0,.954.954",
    transform: "translate(6396.71 -5044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26722",
    "data-name": "Path 26722",
    d: "M19.816,568.27a.956.956,0,0,0,.955-.955v-5.726a.955.955,0,0,0-1.909,0v5.727a.955.955,0,0,0,.954.954",
    transform: "translate(6396.71 -5044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26723",
    "data-name": "Path 26723",
    d: "M44.982,576.43h-.955a.955.955,0,0,0,0,1.909h.955a.955.955,0,0,0,.062-1.909h-.062",
    transform: "translate(6396.71 -5044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26724",
    "data-name": "Path 26724",
    d: "M12.473,576.43h-.955a.955.955,0,0,0-.062,1.909.618.618,0,0,0,.062,0h.955a.955.955,0,0,0,.062-1.909h-.062",
    transform: "translate(6396.71 -5044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22210",
    "data-name": "Rectangle 22210",
    width: 1.909,
    height: 1.909,
    transform: "translate(6407.274 -4457.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22211",
    "data-name": "Rectangle 22211",
    width: 1.909,
    height: 1.909,
    transform: "translate(6411.678 -4444.539) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22212",
    "data-name": "Rectangle 22212",
    width: 1.909,
    height: 1.909,
    transform: "translate(6424.006 -4440.457)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22213",
    "data-name": "Rectangle 22213",
    width: 1.909,
    height: 1.909,
    transform: "translate(6435.526 -4444.536) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22214",
    "data-name": "Rectangle 22214",
    width: 1.909,
    height: 1.909,
    transform: "translate(6440.737 -4457.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26725",
    "data-name": "Path 26725",
    d: "M9.17,556.516a1.759,1.759,0,1,1,1.759-1.759,1.76,1.76,0,0,1-1.759,1.759m0-2.188a.429.429,0,1,0,.429.429.429.429,0,0,0-.429-.429",
    transform: "translate(6396.71 -5044)",
    fill: "#ff7b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26726",
    "data-name": "Path 26726",
    d: "M47.072,608.175a.663.663,0,0,1-.47-.2l-1.5-1.5a.666.666,0,0,1,0-.94l1.5-1.5a.665.665,0,0,1,.94,0h0l1.5,1.5a.666.666,0,0,1,0,.94l-1.5,1.5a.665.665,0,0,1-.471.2m-.561-2.167.561.561.561-.561-.561-.561Z",
    transform: "translate(6396.71 -5044)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26727",
    "data-name": "Path 26727",
    d: "M51.406,566.526a.665.665,0,0,1-.47-.2l-1.5-1.5a.666.666,0,0,1,0-.94l1.5-1.5a.665.665,0,0,1,.94,0h0l1.5,1.5a.666.666,0,0,1,0,.94l-1.5,1.5a.665.665,0,0,1-.471.2m-.562-2.167.561.562.561-.562L51.4,563.8Z",
    transform: "translate(6396.71 -5044)",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26728",
    "data-name": "Path 26728",
    d: "M3.311,601.576a1.1,1.1,0,0,0,1.1-1.1v-1.1h1.1a1.1,1.1,0,0,0,0-2.207h-1.1v-1.1a1.1,1.1,0,1,0-2.207,0v1.1H1.1a1.1,1.1,0,1,0,0,2.207H2.2v1.1a1.1,1.1,0,0,0,1.1,1.1h.007",
    transform: "translate(6396.71 -5044)",
    fill: "#ff7b00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCivilHover);
export default __webpack_public_path__ + "static/media/civilHover.8f6852958e22e6617cc9c527fb27c011.svg";
export { ForwardRef as ReactComponent };